import * as yup from 'yup';

export const personnelValidation = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email().required(),
    country: yup.string().required(),
    state: yup.string().required(),
    phone: yup.string().required(),
});

export const acceptCaseInviteRequest = yup.object().shape({
    personnels: yup.array().of(personnelValidation).required(),
    monetaryClaim: yup.number().nullable(),
    description: yup.string().required(),
    sumToPay: yup.number().nullable(),
    counterClaim: yup.string().nullable(),
    admitToClaims: yup.string().nullable(),
    
})


